package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.entity.RouteBatchResult
import com.milta.feature.route.domain.repository.RouteRepository

/** POST /api/v1/route-batches/{id}/reoptimize (MIL-39). */
class ReoptimizeRouteBatchUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(batchId: String): RouteBatchResult = repository.reoptimizeRouteBatch(batchId)
}
